module.exports = __webpack_public_path__ + "static/media/carta_4.e152afe3.jpg";